import { addDisplayName, addHandlers, addProps, flowMax } from 'ad-hok'
import { FC } from 'react'
import { createUseStyles } from 'react-jss'
import {
  addNavigate,
  addOptionalQueryParam,
} from 'shared/src/utils/addNavigate'

import { addTranslationHelpers } from 'utils/addTranslationHelpers'
import { ConstrainWidth } from 'utils/layout'
import closeButton from '../../assets/close-icon-auth.svg'
import { SetPassword } from './SetPassword'

const useStyles = createUseStyles({
  container: {
    paddingLeft: 24,
    paddingRight: 24,
    paddingTop: 24,
  },
  text: {
    color: '#FFF',
  },
  closeIconContainer: {
    display: 'flex',
    width: '100%',
    justifyContent: 'flex-end',
  },
  closeButton: {
    background: 'none',
    border: 'none',
    padding: 0,
    alignItems: 'flex-end',
  },
})

export const UpdatePassword: FC = flowMax(
  addDisplayName('UpdatePassword'),
  addOptionalQueryParam('email'),
  addOptionalQueryParam('code'),
  addProps(({ email, code }) => ({
    invalidUpdateLink: !email || !code,
  })),
  addNavigate,
  addHandlers({
    onClose:
      ({ navigate }) =>
      () => {
        navigate('/')
      },
  }),
  addTranslationHelpers,
  addProps(() => ({
    classes: useStyles(),
  })),
  ({ email, code, invalidUpdateLink, onClose, classes, t }) => (
    <ConstrainWidth fillHeight>
      <div className={classes.container}>
        <div className={classes.closeIconContainer}>
          <button onClick={onClose} className={classes.closeButton}>
            <img src={closeButton} alt={t('close')} />
          </button>
        </div>
        {invalidUpdateLink || !email ? (
          <div className={classes.text}>problem</div>
        ) : (
          <SetPassword email={email} isUpdate code={code} />
        )}
      </div>
    </ConstrainWidth>
  )
)
